/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Plausible helper (safe no-op if Plausible isn't present) */
(function () {
    if (typeof window.bobPlausibleTrack === 'function') return;

    function toCleanProps(props) {
        if (!props || typeof props !== 'object') return null;
        const out = {};
        for (const [key, value] of Object.entries(props)) {
            if (value === undefined || value === null) continue;
            const cleanKey = String(key || '').trim();
            if (!cleanKey) continue;
            out[cleanKey] = String(value);
        }
        return Object.keys(out).length ? out : null;
    }

    window.bobPlausibleTrack = function (eventName, props) {
        if (!eventName) return;
        if (typeof window.plausible !== 'function') return;
        try {
            const cleanProps = toCleanProps(props);
            if (cleanProps) {
                window.plausible(eventName, { props: cleanProps });
            } else {
                window.plausible(eventName);
            }
        } catch (e) {
            // ignore
        }
    };
})();

/* Key takeaways: move stored block into the header slot */
(function () {
    const slot = document.querySelector('[data-bob-takeaways-slot]');
    if (!slot) return;

    const content = document.querySelector(".gh-content");
    if (!content) return;

    function getSlugFromPath() {
        const raw = String(window.location && window.location.pathname ? window.location.pathname : '');
        const trimmed = raw.replace(/\/+$/, '').replace(/^\/+/, '');
        return trimmed || '(home)';
    }

    // Ghost HTML→Lexical conversion may strip custom wrapper elements/attrs and does not preserve custom ids.
    // So we store takeaways as a stable marker *heading text* + a following <ul> at the top of the body.
    const normalize = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");
    const isTakeawaysHeading = (el) => {
        if (!el) return false;
        if (!/^(h2|h3)$/i.test(el.tagName)) return false;
        const t = normalize(el.textContent);
        return t === "key takeaways" || t === "quick answer" || t === "key points";
    };

    const candidates = Array.from(content.querySelectorAll("h2, h3")).filter(isTakeawaysHeading);
    if (!candidates.length) return;

    // Do not leak takeaways from the members-only preview.
    const marker = candidates.find((el) => !el.closest(".bob-access-preview")) || null;
    if (!marker) return;

    // Only treat it as takeaways if it's near the top of the body.
    const bodyChildren = Array.from(content.children);
    const markerIndex = bodyChildren.indexOf(marker);
    if (markerIndex === -1 || markerIndex > 4) return;

    const list = marker.nextElementSibling;
    if (!list || list.tagName !== "UL") return;

    const wrap = document.createElement("aside");
    wrap.className = "bob-takeaways";

    const header = document.createElement("div");
    header.className = "bob-takeaways-header";

    // Render title as "Key points" (keep storage marker in the editor as "Key takeaways" / "Quick answer" / "Key points").
    marker.classList.add("bob-takeaways-title");
    marker.textContent = "Key points";
    header.appendChild(marker);

    wrap.appendChild(header);
    wrap.appendChild(list);
    slot.appendChild(wrap);
    slot.classList.add('is-loaded');

    const slug = getSlugFromPath();
    window.bobPlausibleTrack('key_points_rendered', {slug});

    let seen = false;
    let read5s = false;
    let visibleMs = 0;
    let visibleSince = null;
    let dwellTimer = null;

    function stopDwellTimer() {
        if (dwellTimer) window.clearTimeout(dwellTimer);
        dwellTimer = null;
    }

    function fireSeen() {
        if (seen) return;
        seen = true;
        window.bobPlausibleTrack('key_points_seen', {slug});
    }

    function fireRead5s() {
        if (read5s) return;
        read5s = true;
        window.bobPlausibleTrack('key_points_read_5s', {slug});
    }

    function onVisible() {
        fireSeen();
        if (read5s) return;
        if (visibleSince == null) visibleSince = Date.now();
        stopDwellTimer();
        const remaining = Math.max(0, 5000 - visibleMs);
        dwellTimer = window.setTimeout(() => {
            if (visibleSince == null) return;
            const now = Date.now();
            visibleMs += Math.max(0, now - visibleSince);
            visibleSince = now;
            if (visibleMs >= 5000) fireRead5s();
        }, remaining);
    }

    function onHidden() {
        if (visibleSince != null) {
            visibleMs += Math.max(0, Date.now() - visibleSince);
            visibleSince = null;
        }
        stopDwellTimer();
    }

    if (typeof IntersectionObserver === 'function') {
        const io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (!entry || entry.target !== wrap) continue;
                if (entry.isIntersecting && (entry.intersectionRatio || 0) >= 0.25) onVisible();
                else onHidden();
            }
        }, { threshold: [0, 0.25, 0.5] });
        io.observe(wrap);
    } else {
        function inView() {
            const r = wrap.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight || 0;
            if (!vh) return false;
            const visibleH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
            return visibleH >= Math.min(80, r.height * 0.25);
        }

        let ticking = false;
        function check() {
            ticking = false;
            if (inView()) onVisible();
            else onHidden();
        }

        function onScroll() {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(check);
        }

        window.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('resize', onScroll);
        check();
    }
})();

/* Review module: lazy-load (only when rendered) */
(function () {
    const modules = document.querySelectorAll('[data-bob-review]');
    if (!modules.length) return;

    const src = window.BOB_REVIEW_MODULE_SRC;
    if (!src) return;

    if (document.querySelector('script[data-bob-review-module]')) return;

    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.dataset.bobReviewModule = '1';
    document.head.appendChild(script);
})();

/* Dark mode toggle (system default) */
(function () {
    const STORAGE_KEY = 'BOB_COLOR_SCHEME';
    const root = document.documentElement;
    const toggles = document.querySelectorAll('[data-theme-toggle]');
    if (!toggles.length) return;

    const defaultSetting = String(root.getAttribute('data-color-scheme-default') || 'System').toLowerCase();
    const media = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;

    function safeGetStored() {
        try {
            return localStorage.getItem(STORAGE_KEY);
        } catch (e) {
            return null;
        }
    }

    function safeSetStored(value) {
        try {
            localStorage.setItem(STORAGE_KEY, value);
        } catch (e) {
            // ignore
        }
    }

    function isExplicitChoice() {
        const stored = safeGetStored();
        return stored === 'light' || stored === 'dark';
    }

    function systemPreference() {
        return media && media.matches ? 'dark' : 'light';
    }

    function getScheme() {
        return root.getAttribute('data-color-scheme') === 'dark' ? 'dark' : 'light';
    }

    function updateThemeColorMeta() {
        const meta = document.querySelector('meta[name="theme-color"]');
        if (!meta) return;
        meta.setAttribute('content', getScheme() === 'dark' ? '#0b0c0f' : '#ffffff');
    }

    function updateLabels() {
        const next = getScheme() === 'dark' ? 'light' : 'dark';
        const label = next === 'dark' ? 'Switch to dark mode' : 'Switch to light mode';
        toggles.forEach((btn) => btn.setAttribute('aria-label', label));
    }

    function applyScheme(scheme, persist) {
        root.setAttribute('data-color-scheme', scheme);
        root.classList.toggle('has-light-text', scheme === 'dark');
        if (persist) safeSetStored(scheme);
        updateLabels();
        updateThemeColorMeta();
        applyPortalThemeToAnyOpenPortal();
    }

    function resolveDefaultScheme() {
        if (defaultSetting === 'light' || defaultSetting === 'dark') return defaultSetting;
        return systemPreference();
    }

    toggles.forEach((btn) => {
        btn.addEventListener('click', function () {
            const current = getScheme();
            const next = getScheme() === 'dark' ? 'light' : 'dark';
            window.bobPlausibleTrack('dark_mode_toggle', { from: current, to: next });
            applyScheme(next, true);
        });
    });

    updateLabels();
    updateThemeColorMeta();
    applyPortalThemeToAnyOpenPortal();

    function schedulePortalThemeRefresh() {
        // Portal is sometimes injected asynchronously (iframe created first, then content populated),
        // so refresh a few times without being too heavy.
        const delays = [0, 150, 400, 900, 1600];
        for (const delay of delays) {
            window.setTimeout(() => applyPortalThemeToAnyOpenPortal(), delay);
        }
    }

    function applyPortalThemeToAnyOpenPortal() {
        const scheme = getScheme();

        const portalSelector = '.gh-portal-popup-container, .gh-portal-popup-wrapper, .gh-portal-content';
        const layoutStyleId = 'bob-portal-layout';
        const themeStyleId = 'bob-portal-theme';
        const notificationSelector = '.gh-portal-notification, .gh-portal-notification-wrapper';
        const notificationStyleId = 'bob-portal-notification';

        function ensureStyle(doc, id, css) {
            let style = doc.getElementById(id);
            if (!style) {
                style = doc.createElement('style');
                style.id = id;
                (doc.head || doc.documentElement).appendChild(style);
            }
            if (style.textContent !== css) {
                style.textContent = css;
            }
        }

        function removeStyle(doc, id) {
            const style = doc.getElementById(id);
            if (style) style.remove();
        }

        function portalLayoutCss() {
            return `
                html, body { background: transparent !important; }
                .gh-portal-popup-container { border-radius: 18px !important; }
                .gh-portal-signup-logo { margin-bottom: 14px !important; max-height: 56px !important; }
                .gh-portal-main-title { font-size: clamp(2.8rem, 2.2vw + 1.8rem, 4.2rem) !important; line-height: 1.1 !important; letter-spacing: -0.02em !important; margin-bottom: 18px !important; }
                .gh-portal-input { border-radius: 12px !important; }
                .gh-portal-btn-primary { border-radius: 12px !important; font-weight: 700 !important; }
                .gh-portal-signup-message, .gh-portal-email-notice, .gh-portal-main-subtitle, .gh-portal-header-message { line-height: 1.5 !important; }
                @media (max-width: 440px) {
                    .gh-portal-popup-wrapper {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        padding: 18px !important;
                        padding-inline-end: 0 !important;
                        margin-inline-end: 0 !important;
                        overflow: hidden !important;
                        height: 100vh !important;
                        max-height: 100vh !important;
                        box-sizing: border-box !important;
                        padding-right: max(18px, env(safe-area-inset-right)) !important;
                        padding-left: max(18px, env(safe-area-inset-left)) !important;
                    }
                    .gh-portal-popup-container {
                        width: 100% !important;
                        max-width: calc(100vw - 36px) !important;
                        margin: 0 auto !important;
                        box-sizing: border-box !important;
                        padding: 18px 18px 16px !important;
                    }
                    .gh-portal-signup-logo { margin-bottom: 10px !important; max-height: 48px !important; }
                    .gh-portal-main-title { font-size: 2.6rem !important; margin-bottom: 12px !important; }
                    .gh-portal-signup-message { font-size: 1.65rem !important; line-height: 1.55 !important; }
                }
            `;
        }

        function portalDarkCss() {
            return `
                :root {
                    --grey2: rgba(255, 255, 255, 0.96) !important;
                    --grey3: rgba(255, 255, 255, 0.88) !important;
                    --grey4: rgba(255, 255, 255, 0.92) !important;
                }
                .gh-portal-popup-background {
                    background: rgba(11, 12, 15, 0.80) !important;
                    position: fixed !important;
                    inset: 0 !important;
                    min-height: 100vh !important;
                }
                .gh-portal-popup-wrapper { min-height: 100vh !important; background: transparent !important; }
                .gh-portal-popup-container { background: #0f1116 !important; color: #ffffff !important; border: 1px solid rgba(255,255,255,0.08) !important; }
                .gh-portal-main-title, .gh-portal-input-label, .gh-portal-signup-header, .gh-portal-content { color: #ffffff !important; }
                .gh-portal-signup-message, .gh-portal-email-notice, .gh-portal-main-subtitle, .gh-portal-header-message { color: rgba(255, 255, 255, 0.92) !important; opacity: 1 !important; }
                .gh-portal-signup-message *, .gh-portal-email-notice *, .gh-portal-main-subtitle *, .gh-portal-header-message * { color: rgba(255, 255, 255, 0.92) !important; opacity: 1 !important; }
                .gh-portal-signup-message strong, .gh-portal-email-notice strong { color: rgba(255, 255, 255, 0.98) !important; }
                .gh-portal-signup-message {
                    padding: 10px 12px !important;
                    margin: 14px 0 0 !important;
                    border-radius: 12px !important;
                    background: rgba(255, 255, 255, 0.06) !important;
                }
                .gh-portal-btn-link, .gh-portal-btn-link span { color: var(--ghost-accent-color, #F77B00) !important; }
                .gh-portal-input { background: #151822 !important; border: 1px solid rgba(255,255,255,0.16) !important; color: #ffffff !important; }
                .gh-portal-input::placeholder { color: rgba(255,255,255,0.55) !important; }
                .gh-portal-btn-primary { background: var(--ghost-accent-color, #F77B00) !important; color: #ffffff !important; }
                .gh-portal-closeicon-container svg { color: #ffffff !important; }
                .gh-portal-closeicon-container svg path { fill: currentColor !important; }
                .gh-portal-signup-logo { filter: invert(1) hue-rotate(180deg) saturate(1.2) brightness(1.05) !important; }
            `;
        }

        function portalNotificationCss() {
            const base = `
                html, body { background: transparent !important; }
                .gh-portal-notification-wrapper { background: transparent !important; }
                :root { background: transparent !important; }
                .gh-portal-notification {
                    box-shadow: none !important;
                    filter: none !important;
                    border-radius: 16px !important;
                    max-width: min(520px, calc(100vw - 32px)) !important;
                }
            `;

            if (scheme === 'dark') {
                return `
                    ${base}
                    .gh-portal-notification {
                        background: #0d1017 !important;
                        color: rgba(255, 255, 255, 0.92) !important;
                        border: 1px solid rgba(255, 255, 255, 0.14) !important;
                    }
                    .gh-portal-notification p { color: rgba(255, 255, 255, 0.90) !important; }
                    .gh-portal-notification p strong { color: rgba(255, 255, 255, 0.96) !important; }
                    .gh-portal-notification a { color: var(--ghost-accent-color, #f77b00) !important; }
                    .gh-portal-notification-closeicon { color: rgba(255, 255, 255, 0.75) !important; }
                `;
            }

            return `
                ${base}
                .gh-portal-notification {
                    background: rgba(255, 255, 255, 0.98) !important;
                    color: rgba(21, 23, 26, 0.92) !important;
                    border: 1px solid rgba(21, 23, 26, 0.10) !important;
                }
                .gh-portal-notification p { color: rgba(21, 23, 26, 0.88) !important; }
                .gh-portal-notification p strong { color: rgba(21, 23, 26, 0.96) !important; }
                .gh-portal-notification a { color: var(--ghost-accent-color, #f77b00) !important; }
                .gh-portal-notification-closeicon { color: rgba(21, 23, 26, 0.60) !important; }
            `;
        }

        function isNotificationFrame(iframe) {
            if (!iframe) return false;
            if (iframe.classList && iframe.classList.contains('gh-portal-notification-iframe')) return true;
            const title = iframe.getAttribute('title') || '';
            if (title === 'portal-notification') return true;
            const testId = iframe.getAttribute('data-testid') || '';
            if (testId === 'portal-notification-frame') return true;
            return false;
        }

        function forceTransparentBackground(doc) {
            try {
                if (doc && doc.documentElement) {
                    doc.documentElement.style.setProperty('background', 'transparent', 'important');
                    doc.documentElement.style.setProperty('background-color', 'transparent', 'important');
                }
                if (doc && doc.body) {
                    doc.body.style.setProperty('background', 'transparent', 'important');
                    doc.body.style.setProperty('background-color', 'transparent', 'important');
                }
            } catch (e) {
                // ignore
            }
        }

        function forceTransparentIframe(iframe) {
            try {
                let bg = '';
                try {
                    bg = window.getComputedStyle(document.body).backgroundColor || '';
                    if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
                        bg = window.getComputedStyle(document.documentElement).backgroundColor || '';
                    }
                } catch (e) {
                    bg = '';
                }
                if (!bg || bg === 'rgba(0, 0, 0, 0)' || bg === 'transparent') {
                    bg = scheme === 'dark' ? '#0b0c0f' : '#ffffff';
                }

                iframe.style.setProperty('background', bg, 'important');
                iframe.style.setProperty('background-color', bg, 'important');
                iframe.style.setProperty('border', '0', 'important');
                iframe.style.setProperty('box-shadow', 'none', 'important');
            } catch (e) {
                // ignore
            }
        }

        function resizeNotificationIframe(iframe, doc) {
            try {
                if (!iframe || !doc) return;
                const toast = doc.querySelector('.gh-portal-notification');
                if (!toast) return;

                const topOffset = 12;
                const bottomPadding = 12;
                const height = Math.min(
                    220,
                    Math.max(80, Math.ceil(topOffset + toast.getBoundingClientRect().height + bottomPadding))
                );
                iframe.style.setProperty('height', `${height}px`, 'important');
            } catch (e) {
                // ignore
            }
        }

        function hidePortalNotificationIframe(iframe) {
            try {
                if (!iframe) return;
                iframe.style.setProperty('display', 'none', 'important');
                iframe.style.setProperty('height', '0', 'important');
                iframe.style.setProperty('width', '0', 'important');
                iframe.style.setProperty('opacity', '0', 'important');
                iframe.style.setProperty('pointer-events', 'none', 'important');
            } catch (e) {
                // ignore
            }
        }

        function splitToastTitleBody(text) {
            const clean = String(text || '').replace(/\s+/g, ' ').trim();
            if (!clean) return { title: '', body: '' };

            const match = clean.match(/^(.{6,90}?)([.!?])\s+(.*)$/);
            if (match) {
                return {
                    title: `${match[1]}${match[2]}`,
                    body: match[3]
                };
            }

            return { title: clean, body: '' };
        }

        function cleanNotificationText(node) {
            if (!node) return '';
            try {
                const clone = node.cloneNode(true);
                const removeSelectors = [
                    'svg',
                    'style',
                    'script',
                    'noscript',
                    'button',
                    '.gh-portal-notification-closeicon',
                    '.gh-portal-notification-close',
                    '.gh-portal-notification-icon',
                ];
                for (const el of clone.querySelectorAll(removeSelectors.join(','))) {
                    el.remove();
                }
                return String(clone.textContent || '').replace(/\s+/g, ' ').trim();
            } catch (e) {
                return String(node.textContent || '').replace(/\s+/g, ' ').trim();
            }
        }

        function extractPortalNotificationMessage(notification) {
            const link = notification.querySelector('a');
            const linkHref = link && link.href ? link.href : null;
            const linkText = link ? String(link.textContent || '').replace(/\s+/g, ' ').trim() : null;

            const paragraph = notification.querySelector('p');
            if (paragraph) {
                const pClone = paragraph.cloneNode(true);
                for (const el of pClone.querySelectorAll('svg, style, script, noscript')) {
                    el.remove();
                }
                if (linkText) {
                    for (const a of pClone.querySelectorAll('a')) {
                        a.remove();
                    }
                }

                const strong = pClone.querySelector('strong');
                if (strong) {
                    const title = String(strong.textContent || '').replace(/\s+/g, ' ').trim();
                    strong.remove();
                    let body = String(pClone.textContent || '').replace(/\s+/g, ' ').trim();
                    body = body.replace(/^[\s:–—-]+/, '').trim();
                    return { title, body, linkHref, linkText };
                }

                const text = String(pClone.textContent || '').replace(/\s+/g, ' ').trim();
                const parsed = splitToastTitleBody(text);
                return { title: parsed.title, body: parsed.body, linkHref, linkText };
            }

            const clean = cleanNotificationText(notification);
            const parsed = splitToastTitleBody(clean);
            return { title: parsed.title, body: parsed.body, linkHref, linkText };
        }

        function showThemeToastFromPortalNotification(iframe, doc) {
            try {
                if (!iframe || !doc) return;

                const notification = doc.querySelector('.gh-portal-notification');
                if (!notification) return;

                const extracted = extractPortalNotificationMessage(notification);
                const rawText = [extracted.title, extracted.body, extracted.linkText].filter(Boolean).join(' ').trim();
                if (!rawText) return;
                if (iframe.dataset.bobMirroredToastText === rawText) return;
                iframe.dataset.bobMirroredToastText = rawText;

                const isError =
                    notification.classList.contains('error') ||
                    /\\b(error|invalid|expired|too many|unable|failed)\\b/i.test(rawText);

                const title = extracted.title || (isError ? 'Something went wrong' : 'Done');
                const body = extracted.body || '';
                const linkHref = extracted.linkHref;
                const linkText = extracted.linkText;

                let existing = document.querySelector('.bob-toast');
                if (existing) existing.remove();

                const toastEl = document.createElement('div');
                toastEl.className = `bob-toast${isError ? ' bob-toast--error' : ''}`;
                toastEl.setAttribute('role', 'status');
                toastEl.setAttribute('aria-live', 'polite');

                const iconEl = document.createElement('div');
                iconEl.className = 'bob-toast__icon';
                iconEl.textContent = isError ? '!' : '✓';

                const contentEl = document.createElement('div');

                const titleEl = document.createElement('p');
                titleEl.className = 'bob-toast__title';
                titleEl.textContent = title;

                const bodyEl = document.createElement('p');
                bodyEl.className = 'bob-toast__body';
                bodyEl.textContent = body;

                if (linkHref && linkText) {
                    const space = body ? ' ' : '';
                    bodyEl.appendChild(document.createTextNode(space));
                    const a = document.createElement('a');
                    a.href = linkHref;
                    a.textContent = linkText;
                    bodyEl.appendChild(a);
                }

                contentEl.appendChild(titleEl);
                if (body || (linkHref && linkText)) {
                    contentEl.appendChild(bodyEl);
                }

                const closeBtn = document.createElement('button');
                closeBtn.type = 'button';
                closeBtn.className = 'bob-toast__close';
                closeBtn.setAttribute('aria-label', 'Close');
                closeBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18.3 5.7a1 1 0 0 0-1.4 0L12 10.6 7.1 5.7A1 1 0 0 0 5.7 7.1L10.6 12l-4.9 4.9a1 1 0 1 0 1.4 1.4l4.9-4.9 4.9 4.9a1 1 0 0 0 1.4-1.4L13.4 12l4.9-4.9a1 1 0 0 0 0-1.4Z" fill="currentColor"/></svg>';
                closeBtn.addEventListener('click', () => toastEl.remove());

                toastEl.appendChild(iconEl);
                toastEl.appendChild(contentEl);
                toastEl.appendChild(closeBtn);
                (document.body || document.documentElement).appendChild(toastEl);

                const timeoutMs = isError ? 12000 : 5500;
                window.setTimeout(() => {
                    if (toastEl && toastEl.parentNode) toastEl.remove();
                }, timeoutMs);
            } catch (e) {
                // ignore
            }
        }

        function ensureNotificationObserver(iframe, doc) {
            try {
                if (!iframe || !doc) return;
                if (iframe._bobNotificationObserver) return;
                if (!doc.body || typeof MutationObserver !== 'function') return;

                const observer = new MutationObserver(() => {
                    try {
                        ensureStyle(doc, notificationStyleId, portalNotificationCss());
                        forceTransparentBackground(doc);
                        forceTransparentIframe(iframe);
                        resizeNotificationIframe(iframe, doc);
                        if (isNotificationFrame(iframe)) {
                            showThemeToastFromPortalNotification(iframe, doc);
                            hidePortalNotificationIframe(iframe);
                        }
                    } catch (e) {
                        // ignore
                    }
                });

                observer.observe(doc.body, { childList: true, subtree: true, attributes: true });
                iframe._bobNotificationObserver = observer;
            } catch (e) {
                // ignore
            }
        }

        // Portal can be injected into the main document (non-iframe) depending on Ghost/Portal version.
        const mainHasPortal = !!document.querySelector(portalSelector);
        let portalInIframes = false;
        for (const iframe of document.querySelectorAll('iframe')) {
            try {
                const doc = iframe.contentDocument;
                if (!doc) continue;
                if (doc.querySelector(portalSelector)) {
                    portalInIframes = true;
                    break;
                }
            } catch (e) {
                // ignore cross-origin frames
            }
        }

        const anyPortalOpen = mainHasPortal || portalInIframes;
        document.documentElement.toggleAttribute('data-bob-portal-open', anyPortalOpen);

        const backdropStyleId = 'bob-portal-backdrop';
        // Conversion-first backdrop: keep the page crisp and use a clean dark scrim in Portal (no blur).
        removeStyle(document, backdropStyleId);
        if (mainHasPortal) {
            ensureStyle(document, layoutStyleId, portalLayoutCss());
            if (scheme === 'dark') {
                ensureStyle(document, themeStyleId, portalDarkCss());
            } else {
                removeStyle(document, themeStyleId);
            }
        } else {
            removeStyle(document, layoutStyleId);
            removeStyle(document, themeStyleId);
        }

        for (const iframe of document.querySelectorAll('iframe')) {
            try {
                const doc = iframe.contentDocument;
                if (!doc) continue;

                const hasPortal = !!doc.querySelector(portalSelector);
                const hasNotification = !!doc.querySelector(notificationSelector);
                const isNotifFrame = isNotificationFrame(iframe);
                if (!hasPortal && !hasNotification) {
                    removeStyle(doc, layoutStyleId);
                    removeStyle(doc, themeStyleId);
                    removeStyle(doc, notificationStyleId);
                    doc.documentElement.removeAttribute('data-bob-color-scheme');
                    continue;
                }

                if (hasPortal) {
                    ensureStyle(doc, layoutStyleId, portalLayoutCss());
                    if (scheme === 'dark') {
                        ensureStyle(doc, themeStyleId, portalDarkCss());
                        doc.documentElement.setAttribute('data-bob-color-scheme', 'dark');
                    } else {
                        removeStyle(doc, themeStyleId);
                        doc.documentElement.removeAttribute('data-bob-color-scheme');
                    }
                } else {
                    removeStyle(doc, layoutStyleId);
                    removeStyle(doc, themeStyleId);
                }

                if (hasNotification || isNotifFrame) {
                    ensureStyle(doc, notificationStyleId, portalNotificationCss());
                    forceTransparentBackground(doc);
                    forceTransparentIframe(iframe);
                    resizeNotificationIframe(iframe, doc);
                    if (isNotifFrame) {
                        showThemeToastFromPortalNotification(iframe, doc);
                        hidePortalNotificationIframe(iframe);
                        ensureNotificationObserver(iframe, doc);
                    }

                    if (isNotifFrame && !iframe.dataset.bobToastPatched) {
                        iframe.dataset.bobToastPatched = '1';
                        const delays = [0, 80, 220, 600, 1200, 2200, 3500, 5000];
                        for (const delay of delays) {
                            window.setTimeout(() => {
                                try {
                                    const nextDoc = iframe.contentDocument;
                                    if (nextDoc) {
                                        ensureStyle(nextDoc, notificationStyleId, portalNotificationCss());
                                        forceTransparentBackground(nextDoc);
                                        resizeNotificationIframe(iframe, nextDoc);
                                        ensureNotificationObserver(iframe, nextDoc);
                                    }
                                    forceTransparentIframe(iframe);
                                } catch (e) {
                                    // ignore
                                }
                            }, delay);
                        }
                    }
                } else {
                    removeStyle(doc, notificationStyleId);
                }
            } catch (e) {
                // ignore cross-origin frames
            }
        }
    }

    const portalObserver = new MutationObserver(() => applyPortalThemeToAnyOpenPortal());
    try {
        portalObserver.observe(document.body, { childList: true, subtree: true });
    } catch (e) {
        // ignore
    }

    // If a Portal iframe is inserted before its content is ready, listen for `load` and re-apply.
    document.addEventListener('load', (event) => {
        const target = event.target;
        if (!target || target.tagName !== 'IFRAME') return;
        schedulePortalThemeRefresh();
    }, true);

    // Portal opens on click of `[data-portal]` elements; refresh shortly after clicks too.
    document.addEventListener('click', (event) => {
        const el = event.target && event.target.closest ? event.target.closest('[data-portal]') : null;
        if (!el) return;
        schedulePortalThemeRefresh();
    }, true);

    if (!isExplicitChoice() && defaultSetting === 'system' && media) {
        const onChange = function () {
            if (isExplicitChoice()) return;
            applyScheme(systemPreference(), false);
        };

        if (typeof media.addEventListener === 'function') {
            media.addEventListener('change', onChange);
        } else if (typeof media.addListener === 'function') {
            media.addListener(onChange);
        }
    }
})();

/* Plausible: site search tracking (open + result clicks) */
(function () {
    if (typeof window.bobPlausibleTrack !== 'function') return;

    function toInternalPath(href) {
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return null;
        let url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return null;
        }
        if (url.origin !== window.location.origin) return null;
        return url.pathname || null;
    }

    function classifyKind(pathname) {
        const p = String(pathname || '');
        if (!p) return 'unknown';
        if (p.startsWith('/tag/')) return 'tag';
        if (p.startsWith('/author/')) return 'author';
        if (p === '/' || p.startsWith('/page/')) return 'page';
        return 'post';
    }

    function placementFromTriggerEl(el) {
        if (!el) return 'unknown';
        try {
            if (el.closest('#gh-navigation') || el.closest('.gh-navigation') || el.closest('nav')) return 'nav';
            if (el.closest('.bob-404')) return '404';
            if (el.closest('header')) return 'header';
        } catch (e) {
            // ignore
        }
        return 'unknown';
    }

    let lastPlacement = 'unknown';
    let openPlacement = 'unknown';
    let openTracked = false;
    let rootEl = null;

    function isOpen() {
        if (!rootEl) return false;
        // Sodo Search typically mounts an iframe (same-origin) into this root.
        if (rootEl.querySelector && rootEl.querySelector('iframe')) return true;
        // Fallback: treat any content as "open".
        return Boolean(rootEl.childNodes && rootEl.childNodes.length);
    }

    function maybeTrackOpen() {
        if (openTracked) return;
        if (!isOpen()) return;
        openTracked = true;
        openPlacement = lastPlacement || 'unknown';
        window.bobPlausibleTrack('search_open', {placement: openPlacement});
    }

    function resetIfClosed() {
        if (openTracked && !isOpen()) {
            openTracked = false;
            openPlacement = 'unknown';
        }
    }

    function trackResultClick(toPath) {
        if (!toPath) return;
        window.bobPlausibleTrack('search_result_click', {
            to: toPath,
            kind: classifyKind(toPath),
            placement: openPlacement || lastPlacement || 'unknown',
        });
    }

    function trackFromEvent(event) {
        const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (!link) return;
        const to = toInternalPath(link.getAttribute('href'));
        if (!to) return;
        trackResultClick(to);
    }

    function attachToIframe(iframe) {
        if (!iframe || iframe.__bobSearchClickTrackingAttached) return;
        iframe.__bobSearchClickTrackingAttached = true;

        function tryAttach() {
            try {
                const doc = iframe.contentDocument;
                if (!doc || doc.__bobSearchClickTrackingAttached) return;
                doc.__bobSearchClickTrackingAttached = true;
                doc.addEventListener('click', trackFromEvent, true);
            } catch (e) {
                // ignore cross-origin
            }
        }

        iframe.addEventListener('load', tryAttach, {once: false});
        tryAttach();
    }

    function attachToRoot(el) {
        if (!el || el.__bobSearchTrackingAttached) return;
        el.__bobSearchTrackingAttached = true;
        rootEl = el;

        // If search renders in the main document, scope tracking to inside the root.
        el.addEventListener('click', (event) => {
            if (!openTracked) maybeTrackOpen();
            trackFromEvent(event);
        }, true);

        if (typeof MutationObserver !== 'function') return;
        const observer = new MutationObserver(() => {
            maybeTrackOpen();
            resetIfClosed();
            const iframe = el.querySelector && el.querySelector('iframe');
            if (iframe) attachToIframe(iframe);
        });
        observer.observe(el, {childList: true, subtree: true, attributes: true});

        // Initial check
        maybeTrackOpen();
        resetIfClosed();
        const iframe = el.querySelector && el.querySelector('iframe');
        if (iframe) attachToIframe(iframe);
    }

    // Track "open intent" from the trigger button, but also detect opens from keyboard/other paths.
    document.addEventListener('click', function (event) {
        const el = event.target && event.target.closest ? event.target.closest('[data-ghost-search]') : null;
        if (!el) return;
        lastPlacement = placementFromTriggerEl(el);
        // Sodo Search may mount asynchronously; do a best-effort follow-up.
        window.setTimeout(() => {
            if (rootEl) maybeTrackOpen();
        }, 0);
    }, true);

    // Find/attach to Sodo Search root when it appears.
    function findAndAttach() {
        const existing = document.getElementById('sodo-search-root');
        if (existing) attachToRoot(existing);
    }

    findAndAttach();
    if (typeof MutationObserver !== 'function') return;
    const bodyObserver = new MutationObserver(() => findAndAttach());
    try {
        bodyObserver.observe(document.body, {childList: true, subtree: true});
    } catch (e) {
        // ignore
    }
})();

/* Plausible: related post click tracking (sidebar + below "Read more") */
(function () {
    function toInternalPath(href) {
        if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return null;
        let url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return null;
        }
        if (url.origin !== window.location.origin) return null;
        return url.pathname || null;
    }

    document.addEventListener('click', function (event) {
        const sidebarLink = event.target && event.target.closest ? event.target.closest('.bob-sidebar-post-link') : null;
        if (sidebarLink) {
            const to = toInternalPath(sidebarLink.getAttribute('href'));
            window.bobPlausibleTrack('related_click_sidebar', { to });
            return;
        }

        const belowLink = event.target && event.target.closest ? event.target.closest('.bob-related-below .gh-card-link') : null;
        if (belowLink) {
            const to = toInternalPath(belowLink.getAttribute('href'));
            window.bobPlausibleTrack('related_click_below', { to });
        }
    }, true);
})();

/* Plausible: post read-depth milestones (50% + 90%) */
(function () {
    if (!document.body || !(document.body.classList.contains('post-template') || document.body.classList.contains('single-post'))) return;
    const article = document.querySelector('.gh-article');
    if (!article) return;

    const storageKey = `BOB_POST_READ_MILESTONES:${window.location.pathname || ''}`;
    const fired = new Set();

    try {
        const raw = sessionStorage.getItem(storageKey);
        if (raw) {
            raw.split(',').map((s) => s.trim()).filter(Boolean).forEach((v) => fired.add(v));
        }
    } catch (e) {
        // ignore
    }

    function remember(key) {
        fired.add(key);
        try {
            sessionStorage.setItem(storageKey, Array.from(fired).join(','));
        } catch (e) {
            // ignore
        }
    }

    function getPostScrollPercent() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const articleTop = article.getBoundingClientRect().top + scrollTop;
        const articleBottom = articleTop + article.offsetHeight;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const totalScrollable = Math.max(0, articleBottom - articleTop - viewportHeight);
        if (totalScrollable <= 0) return 100;
        const current = Math.min(Math.max(scrollTop - articleTop, 0), totalScrollable);
        return (current / totalScrollable) * 100;
    }

    let ticking = false;
    function check() {
        ticking = false;
        const pct = getPostScrollPercent();
        if (pct >= 50 && !fired.has('50')) {
            window.bobPlausibleTrack('post_read_50');
            remember('50');
        }
        if (pct >= 90 && !fired.has('90')) {
            window.bobPlausibleTrack('post_read_90');
            remember('90');
        }
        if (fired.has('50') && fired.has('90')) {
            window.removeEventListener('scroll', onScroll, { passive: true });
            window.removeEventListener('resize', onScroll);
        }
    }

    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
})();

/* Plausible: member gate (paywall) impressions + CTA clicks */
(function () {
    const gate = document.querySelector('.bob-access-cta');
    if (!gate) return;

    const isMember = document.body && document.body.getAttribute('data-bob-member') === '1';
    const viewer = isMember ? 'member' : 'anon';
    const gateType = gate.getAttribute('data-bob-member-gate') || 'unknown';

    let shown = false;

    function fireShown() {
        if (shown) return;
        shown = true;
        window.bobPlausibleTrack('member_gate_shown', { gate: gateType, viewer });
    }

    if (typeof IntersectionObserver === 'function') {
        const io = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                fireShown();
                io.disconnect();
                break;
            }
        }, { threshold: 0.25 });
        io.observe(gate);
    } else {
        // Fallback: trigger once when the gate is in view.
        function inView() {
            const r = gate.getBoundingClientRect();
            return r.bottom >= 0 && r.top <= (window.innerHeight || document.documentElement.clientHeight || 0);
        }
        if (inView()) {
            fireShown();
        } else {
            const onScroll = () => {
                if (!inView()) return;
                fireShown();
                window.removeEventListener('scroll', onScroll, { passive: true });
            };
            window.addEventListener('scroll', onScroll, { passive: true });
        }
    }

    gate.addEventListener('click', function (event) {
        const target = event.target && event.target.closest ? event.target.closest('a, button') : null;
        if (!target) return;
        if (!gate.contains(target)) return;

        const modalAction = target.getAttribute('data-bob-members-modal') || target.getAttribute('data-bob-members-modal-open');
        const portalAction = target.getAttribute('data-portal');
        const action = modalAction || portalAction || 'unknown';

        window.bobPlausibleTrack('member_gate_cta_click', { gate: gateType, viewer, action });
    }, true);
})();

/* Plausible: footer signup form funnel */
(function () {
    const wrap = document.querySelector('.gh-footer-signup');
    if (!wrap) return;

    const form = wrap.querySelector('form[data-members-form]');
    if (!form) return;

    let sentSubmit = false;
    let sentSuccess = false;
    let sentError = false;

    function maybeTrackSuccess() {
        if (sentSuccess) return;
        if (form.classList.contains('success')) {
            sentSuccess = true;
            window.bobPlausibleTrack('footer_signup_success');
        }
    }

    function maybeTrackError() {
        if (sentError) return;
        const errorEl = form.querySelector('[data-members-error]');
        const msg = errorEl ? String(errorEl.textContent || '').trim() : '';
        if (!msg) return;
        sentError = true;
        window.bobPlausibleTrack('footer_signup_error');
    }

    form.addEventListener('submit', function () {
        if (!sentSubmit) {
            sentSubmit = true;
            window.bobPlausibleTrack('footer_signup_submit');
        }
        // The Ghost members script updates the form state asynchronously; watch for success/error.
        window.setTimeout(() => {
            maybeTrackSuccess();
            maybeTrackError();
        }, 0);
    }, true);

    const observer = new MutationObserver(() => {
        maybeTrackSuccess();
        maybeTrackError();
    });
    observer.observe(form, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
})();

/* Affiliate link hygiene: ensure product-card links are marked sponsored */
(function () {
    const links = Array.from(document.querySelectorAll('.kg-product-card a[href]'));
    if (!links.length) return;

    function isAmazonUrl(href) {
        try {
            const url = new URL(href, window.location.href);
            const host = url.hostname.toLowerCase();
            if (host === 'amzn.to' || host.endsWith('.amzn.to')) return true;
            if (host === 'amazon.com' || host.endsWith('.amazon.com')) return true;
            if (host === 'amazon.co.uk' || host.endsWith('.amazon.co.uk')) return true;
            if (host === 'amazon.ca' || host.endsWith('.amazon.ca')) return true;
            if (host === 'amazon.de' || host.endsWith('.amazon.de')) return true;
            if (host === 'amazon.fr' || host.endsWith('.amazon.fr')) return true;
            if (host === 'amazon.it' || host.endsWith('.amazon.it')) return true;
            if (host === 'amazon.es' || host.endsWith('.amazon.es')) return true;
            if (host === 'amazon.com.au' || host.endsWith('.amazon.com.au')) return true;
            return false;
        } catch (e) {
            return false;
        }
    }

    function normalizeRel(rel) {
        const parts = new Set((rel || '').split(/\s+/).filter(Boolean));
        ['sponsored', 'nofollow', 'noopener', 'noreferrer'].forEach((item) => parts.add(item));
        return Array.from(parts).join(' ');
    }

    links.forEach((link) => {
        const href = String(link.getAttribute('href') || '').trim();
        if (!href || !isAmazonUrl(href)) return;
        link.setAttribute('rel', normalizeRel(link.getAttribute('rel')));
        if (!link.getAttribute('target')) link.setAttribute('target', '_blank');
    });
})();

/* Members modal: custom signup/signin (autofill-friendly) + optional auto-popup */
(function () {
    const modalRoot = document.querySelector('[data-bob-members-modal-root]');
    if (!modalRoot) return;

    const dialog = modalRoot.querySelector('.bob-members-modal__dialog');
    const panels = Array.from(modalRoot.querySelectorAll('[data-bob-members-panel]'));
    const closeButtons = Array.from(modalRoot.querySelectorAll('[data-bob-members-modal-close]'));

    const STORAGE = {
        dismissedAt: 'BOB_MEMBERS_MODAL_DISMISSED_AT',
        subscribed: 'BOB_MEMBERS_MODAL_SUBSCRIBED',
        magicLinkSentAt: 'BOB_MEMBERS_MODAL_MAGIC_LINK_SENT_AT',
        shownThisSession: 'BOB_MEMBERS_MODAL_SHOWN_SESSION',
        disabled: 'BOB_MEMBERS_MODAL_DISABLED',
        lastSubmitMeta: 'BOB_MEMBERS_MODAL_LAST_SUBMIT_META',
        confirmedAt: 'BOB_MEMBERS_MODAL_CONFIRMED_AT',
        rateLimitUntil: 'BOB_MEMBERS_MODAL_RATE_LIMIT_UNTIL'
    };

    const COOLDOWN_DAYS = 14;
    const COOLDOWN_MS = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    const MAGIC_LINK_COOLDOWN_DAYS = 7;
    const MAGIC_LINK_COOLDOWN_MS = MAGIC_LINK_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
    const CONFIRM_WINDOW_MS = 24 * 60 * 60 * 1000;
    const RATE_LIMIT_BLOCK_MS = 60 * 1000;

    let isOpen = false;
    let lastActiveElement = null;
    let lastOpenMeta = null;

    function safeGet(storage, key) {
        try {
            return storage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function safeSet(storage, key, value) {
        try {
            storage.setItem(key, value);
        } catch (e) {
            // ignore
        }
    }

    function safeRemove(storage, key) {
        try {
            storage.removeItem(key);
        } catch (e) {
            // ignore
        }
    }

    function safeJsonParse(raw) {
        try {
            return JSON.parse(String(raw || ''));
        } catch (e) {
            return null;
        }
    }

    function isPlausibleAvailable() {
        return typeof window.plausible === 'function';
    }

    function trackEvent(eventName, props) {
        if (!eventName) return;
        if (!isPlausibleAvailable()) return;
        try {
            const cleanProps = props && typeof props === 'object' ? props : null;
            if (cleanProps) {
                window.plausible(eventName, { props: cleanProps });
            } else {
                window.plausible(eventName);
            }
        } catch (e) {
            // ignore
        }
    }

    function isMember() {
        return document.body && document.body.getAttribute('data-bob-member') === '1';
    }

    function membersEnabled() {
        return document.body && document.body.getAttribute('data-bob-members-enabled') === '1';
    }

    function inviteOnly() {
        return document.body && document.body.getAttribute('data-bob-members-invite-only') === '1';
    }

    function getPlacementFromElement(el) {
        if (!el || !el.closest) return 'unknown';
        if (el.closest('.bob-audio-inline')) return 'audio_inline';
        if (el.closest('.bob-audio')) return 'audio_teaser';
        if (el.closest('.bob-access-cta')) return 'post_gate';
        if (el.closest('#gh-navigation') || el.closest('.gh-navigation') || el.closest('nav')) return 'nav';
        if (el.closest('.gh-feed') || el.closest('.post-card') || el.closest('.bob-post-list')) return 'post_list';
        if (el.closest('.gh-article')) return 'post_body';
        return 'unknown';
    }

    function trackMemberGateClickFromModalOpen(el, action) {
        const gate = el && el.closest ? el.closest('.bob-access-cta') : null;
        if (!gate) return;

        trackEvent('member_gate_cta_click', {
            gate: gate.getAttribute('data-bob-member-gate') || 'unknown',
            viewer: isMember() ? 'member' : 'anon',
            action: action || 'unknown'
        });
    }

    function normalizeTriggerMeta(meta) {
        const trigger = meta && (meta.trigger === 'auto' || meta.trigger === 'manual') ? meta.trigger : 'manual';
        const placement =
            meta && typeof meta.placement === 'string' && meta.placement.trim()
                ? meta.placement.trim()
                : meta && meta.openedByEl
                    ? getPlacementFromElement(meta.openedByEl)
                    : 'unknown';
        const threshold = meta && Number.isFinite(Number(meta.scrollThreshold)) ? Number(meta.scrollThreshold) : null;
        return {trigger, placement, threshold};
    }

    function autoPopupEnabledByTheme() {
        return document.body && document.body.getAttribute('data-bob-members-autopopup') === '1';
    }

    function setPanel(name) {
        const target = String(name || 'signup');
        panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.getAttribute('data-bob-members-panel') === target);
        });
    }

    function shouldAutoFocusEmail() {
        // On mobile, focusing the email input opens the keyboard and can push the modal up
        // aggressively (hurts UX on small screens). Prefer a stable modal and let the user tap.
        try {
            if (window.matchMedia) {
                if (window.matchMedia('(pointer: coarse)').matches) return false;
                if (window.matchMedia('(hover: none)').matches) return false;
            }
        } catch (e) {
            // ignore
        }
        if ((window.innerWidth || 0) < 768) return false;
        return true;
    }

    function focusPrimaryField() {
        const activePanel = modalRoot.querySelector('[data-bob-members-panel].is-active');
        if (!activePanel) return;
        const input = activePanel.querySelector('input[data-members-email]');
        if (input) input.focus();
    }

    function openModal(panel, meta = {}) {
        if (!membersEnabled() || inviteOnly()) return;
        if (isMember()) return;
        if (isOpen) {
            setPanel(panel || 'signup');
            if (shouldAutoFocusEmail()) window.setTimeout(focusPrimaryField, 0);
            return;
        }

        // If the user opens the modal manually, don’t also show an auto-popup later in the same session.
        safeSet(sessionStorage, STORAGE.shownThisSession, '1');

        // Always start from the default heading + default form UI when opening.
        setModalHeadingDefault();
        for (const form of Array.from(modalRoot.querySelectorAll('form[data-bob-members-form]'))) {
            resetFormToDefault(form, {focus: false});
        }

        lastActiveElement = document.activeElement;
        setPanel(panel || 'signup');

        modalRoot.hidden = false;
        document.documentElement.classList.add('bob-modal-open');
        isOpen = true;
        lastOpenMeta = normalizeTriggerMeta(meta);

        const shownEvent = lastOpenMeta.trigger === 'auto' ? 'members_modal_shown_auto' : 'members_modal_shown_manual';
        trackEvent(shownEvent, {
            placement: lastOpenMeta.placement,
            threshold: lastOpenMeta.threshold != null ? String(lastOpenMeta.threshold) : undefined
        });

        if (dialog) {
            dialog.scrollTop = 0;
            dialog.focus();
        }

        if (shouldAutoFocusEmail()) window.setTimeout(focusPrimaryField, 0);
    }

    // If the visitor is already a member (logged in), mark the browser as “subscribed” so we never
    // auto-popup again even if they later log out on this device.
    if (isMember()) {
        safeSet(localStorage, STORAGE.subscribed, '1');
    }

    // If the visitor clicks the magic link and returns as a member shortly after, count that as a
    // one-time "confirmed" conversion event (separate from "magic link sent").
    (function trackConfirmedIfApplicable() {
        if (!isPlausibleAvailable()) return;
        if (!isMember()) return;
        if (safeGet(localStorage, STORAGE.confirmedAt)) return;

        const magicLinkSentAtRaw = safeGet(localStorage, STORAGE.magicLinkSentAt);
        const magicLinkSentAt = magicLinkSentAtRaw ? Number(magicLinkSentAtRaw) : 0;
        if (!magicLinkSentAt || !Number.isFinite(magicLinkSentAt)) return;
        if (Date.now() - magicLinkSentAt > CONFIRM_WINDOW_MS) return;

        const meta = safeJsonParse(safeGet(localStorage, STORAGE.lastSubmitMeta)) || {};
        trackEvent('members_confirmed', {
            trigger: meta && meta.trigger ? String(meta.trigger) : undefined,
            placement: meta && meta.placement ? String(meta.placement) : undefined,
            form: meta && meta.form ? String(meta.form) : undefined,
            threshold: meta && meta.threshold != null ? String(meta.threshold) : undefined
        });

        safeSet(localStorage, STORAGE.confirmedAt, String(Date.now()));
        safeRemove(localStorage, STORAGE.lastSubmitMeta);
    })();

    function closeModal({persistDismissal, reason} = {persistDismissal: true, reason: 'dismiss'}) {
        if (!isOpen) return;
        isOpen = false;

        modalRoot.hidden = true;
        document.documentElement.classList.remove('bob-modal-open');

        // Reset heading and form UI so the next open starts clean.
        setModalHeadingDefault();
        for (const form of Array.from(modalRoot.querySelectorAll('form[data-bob-members-form]'))) {
            resetFormToDefault(form, {focus: false});
        }

        if (persistDismissal) {
            safeSet(localStorage, STORAGE.dismissedAt, String(Date.now()));
        }

        trackEvent('members_modal_dismissed', {
            reason: String(reason || 'dismiss'),
            trigger: lastOpenMeta ? lastOpenMeta.trigger : undefined,
            placement: lastOpenMeta ? lastOpenMeta.placement : undefined
        });
        lastOpenMeta = null;

        if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
            lastActiveElement.focus();
        }
        lastActiveElement = null;
    }

    function getFocusableElements() {
        if (!dialog) return [];
        const selectors = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ];
        return Array.from(dialog.querySelectorAll(selectors.join(','))).filter((el) => el.offsetParent !== null);
    }

    function trapFocus(event) {
        if (!isOpen || event.key !== 'Tab') return;
        const focusable = getFocusableElements();
        if (!focusable.length) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const active = document.activeElement;

        if (event.shiftKey) {
            if (active === first || active === dialog) {
                event.preventDefault();
                last.focus();
            }
        } else {
            if (active === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }

    function portalActionFromHref(rawHref) {
        const href = String(rawHref || '').trim();
        if (!href) return null;

        // Common cases:
        // - "#/portal/signup"
        // - "/#/portal/signup"
        // - "https://blendofbites.com/post/#/portal/signup"
        // - "https://blendofbites.com/#/portal/signin"
        let hash = '';
        if (href.startsWith('#/portal/')) {
            hash = href;
        } else if (href.startsWith('/#/portal/')) {
            hash = href.slice(1);
        } else {
            const idx = href.indexOf('#/portal/');
            if (idx !== -1) hash = href.slice(idx);
        }

        if (!hash) return null;
        if (hash.startsWith('#/portal/signin')) return 'signin';
        if (hash.startsWith('#/portal/signup')) return 'signup';
        return null;
    }

    function suppressPortalPopupIfPresent() {
        // Portal popup UI is injected by Ghost into the main page DOM (with a popup iframe).
        // If a Portal popup is already open (or opens asynchronously), hide it so our theme-native
        // members modal is the only visible UI.
        const selectors = [
            '.gh-portal-popup-container',
            '.gh-portal-popup-wrapper',
            'iframe.gh-portal-popup-iframe',
            '.gh-portal-backdrop',
            '.gh-portal-popup-overlay'
        ];
        for (const selector of selectors) {
            for (const el of Array.from(document.querySelectorAll(selector))) {
                try {
                    el.style.setProperty('display', 'none', 'important');
                    el.style.setProperty('visibility', 'hidden', 'important');
                    el.style.setProperty('pointer-events', 'none', 'important');
                    el.setAttribute('aria-hidden', 'true');
                } catch (e) {
                    // ignore
                }
            }
        }
    }

    function schedulePortalSuppression() {
        // Portal can inject the popup asynchronously after a hash change; suppress a few times.
        const delays = [0, 50, 150, 400, 900];
        for (const delay of delays) {
            window.setTimeout(suppressPortalPopupIfPresent, delay);
        }
    }

    document.addEventListener('click', (event) => {
        const openEl = event.target && event.target.closest ? event.target.closest('[data-bob-members-modal], [data-bob-members-modal-open]') : null;
        if (openEl) {
            const panel =
                openEl.getAttribute('data-bob-members-modal') ||
                openEl.getAttribute('data-bob-members-modal-open') ||
                'signup';
            event.preventDefault();
            event.stopPropagation();
            if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
            schedulePortalSuppression();
            trackMemberGateClickFromModalOpen(openEl, panel);
            if (isOpen) {
                setPanel(panel);
                window.setTimeout(focusPrimaryField, 0);
            } else {
                openModal(panel, {trigger: 'manual', openedByEl: openEl});
            }
            return;
        }

        // In post bodies, Ghost often strips custom `data-*` attributes from HTML.
        // We still want `#/portal/signup` + `#/portal/signin` links to open our theme-native modal,
        // instead of the default Portal overlay.
        const linkEl = event.target && event.target.closest ? event.target.closest('a[href]') : null;
        if (linkEl) {
            const href = linkEl.getAttribute('href');
            const action = portalActionFromHref(href);
            if (action && membersEnabled() && !inviteOnly() && !isMember()) {
                event.preventDefault();
                event.stopPropagation();
                if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
                schedulePortalSuppression();
                trackMemberGateClickFromModalOpen(linkEl, action);
                if (isOpen) {
                    setPanel(action);
                    window.setTimeout(focusPrimaryField, 0);
                } else {
                    openModal(action, {trigger: 'manual', openedByEl: linkEl});
                }
                return;
            }
        }

        const closeEl = event.target && event.target.closest ? event.target.closest('[data-bob-members-modal-close]') : null;
        if (closeEl) {
            event.preventDefault();
            const reason =
                closeEl.classList && closeEl.classList.contains('bob-members-modal__backdrop')
                    ? 'backdrop'
                    : closeEl.classList && closeEl.classList.contains('bob-members-modal__close')
                        ? 'close'
                        : 'close';
            closeModal({persistDismissal: true, reason});
        }
    }, true);

    function clearPortalHashIfPresent() {
        const hash = String(window.location.hash || '');
        if (!hash.startsWith('#/portal/')) return;
        try {
            history.replaceState(null, document.title, window.location.pathname + window.location.search);
        } catch (e) {
            // ignore
        }
    }

    function openFromPortalHashIfNeeded() {
        const hash = String(window.location.hash || '').trim();
        const action =
            hash.startsWith('#/portal/signin') ? 'signin'
                : hash.startsWith('#/portal/signup') ? 'signup'
                    : null;
        if (!action) return;
        if (!membersEnabled() || inviteOnly() || isMember()) return;
        schedulePortalSuppression();
        openModal(action, {trigger: 'manual', placement: 'hash'});
        clearPortalHashIfPresent();
        schedulePortalSuppression();
    }

    // If a visitor lands on a URL with a Portal hash (ex: `/#/portal/signup`),
    // open the theme-native modal and remove the hash to avoid the default Portal overlay.
    openFromPortalHashIfNeeded();
    window.addEventListener('hashchange', openFromPortalHashIfNeeded, {passive: true});

    closeButtons.forEach((btn) => {
        btn.addEventListener('click', (event) => {
            event.preventDefault();
            closeModal({persistDismissal: true, reason: 'close'});
        });
    });

    document.addEventListener('keydown', (event) => {
        if (!isOpen) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            closeModal({persistDismissal: true, reason: 'escape'});
            return;
        }
        trapFocus(event);
    });

    const modalTitle = modalRoot.querySelector('.bob-members-modal__title');
    const modalSubtitle = modalRoot.querySelector('.bob-members-modal__subtitle');
    const defaultHeading = {
        title: modalTitle ? modalTitle.textContent : '',
        subtitle: modalSubtitle ? modalSubtitle.textContent : ''
    };

    function setModalHeadingDefault() {
        if (modalTitle) modalTitle.textContent = defaultHeading.title;
        if (modalSubtitle) modalSubtitle.textContent = defaultHeading.subtitle;
    }

    function setModalHeadingSuccess(email) {
        if (modalTitle) modalTitle.textContent = 'Check your email';
        if (modalSubtitle) {
            modalSubtitle.textContent =
                `We sent a sign-in link to ${email}. Tap it to confirm — you’ll be signed in and returned to this page.`;
        }
    }

    function setFormState(form, state) {
        form.classList.toggle('loading', state === 'loading');
        form.classList.toggle('success', state === 'success');
        form.classList.toggle('error', state === 'error');
        form.classList.remove('invalid');

        const submitBtn = form.querySelector('.bob-members-form__submit');
        if (submitBtn) {
            const defaultLabel = submitBtn.getAttribute('data-bob-default-label') || submitBtn.textContent || 'Submit';
            submitBtn.disabled = state === 'loading' || state === 'success';
            submitBtn.textContent = state === 'loading' ? 'Sending…' : defaultLabel;
        }
    }

    function setFormError(form, message) {
        const errorEl = form.querySelector('[data-members-error]') || form.querySelector('.bob-members-form__error');
        if (!errorEl) return;
        errorEl.textContent = message || '';
    }

    async function readGhostError(res) {
        const contentType = (res.headers && res.headers.get && res.headers.get('content-type')) || '';
        if (contentType.includes('application/json')) {
            const json = await res.json().catch(() => null);
            const first = json && json.errors && json.errors[0] ? json.errors[0] : null;
            if (first && (first.message || first.help)) {
                const msg = String(first.message || '').trim();
                const help = String(first.help || '').trim();
                return help ? `${msg} ${help}`.trim() : msg;
            }
        }
        const text = await res.text().catch(() => '');
        return String(text || '').trim() || `Request failed (${res.status})`;
    }

    function buildMemberLabels({formType} = {formType: 'signup'}) {
        const labels = ['members-modal'];

        const trigger = lastOpenMeta && lastOpenMeta.trigger ? lastOpenMeta.trigger : 'unknown';
        labels.push(trigger === 'auto' ? 'members-modal-auto' : trigger === 'manual' ? 'members-modal-manual' : 'members-modal-unknown');

        const placement = lastOpenMeta && lastOpenMeta.placement ? lastOpenMeta.placement : 'unknown';
        labels.push(`members-modal-${placement}`);

        if (trigger === 'auto' && lastOpenMeta && lastOpenMeta.threshold != null) {
            labels.push(`members-modal-scroll${String(lastOpenMeta.threshold)}`);
        }

        const normalizedForm = formType === 'signin' ? 'signin' : 'signup';
        labels.push(`members-modal-${normalizedForm}`);

        return labels;
    }

    function normalizeFriendlyError(raw) {
        const msg = String(raw || '').trim();
        if (!msg) return 'Please try again.';
        if (msg.toLowerCase().includes('too many requests') || msg.includes('429')) {
            return 'Too many requests. Please wait a minute and try again.';
        }
        if (msg.toLowerCase().includes('failed to send email')) {
            return 'This Ghost site is not configured to send emails yet. Please see https://ghost.org/docs/config/#mail';
        }
        return msg;
    }

    function isRateLimitMessage(message) {
        const msg = String(message || '').toLowerCase();
        return msg.includes('too many requests') || msg.includes('429');
    }

    async function requestMagicLink({email, name, labels}) {
        const tokenRes = await fetch('/members/api/integrity-token/', {method: 'GET', credentials: 'same-origin'});
        if (!tokenRes.ok) {
            throw new Error('Could not start signup. Please refresh and try again.');
        }
        const integrityToken = await tokenRes.text();

        const payload = {
            email,
            name: name || undefined,
            labels: Array.isArray(labels) ? labels : [],
            integrityToken
        };

        const res = await fetch('/members/api/send-magic-link/', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(payload)
        });

        if (!res.ok) {
            throw new Error(await readGhostError(res));
        }
    }

    function applySuccessUI({form, email}) {
        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
            emailInput.disabled = true;
            emailInput.setAttribute('aria-disabled', 'true');
        }
        setModalHeadingSuccess(email);
    }

    function resetFormToDefault(form, {focus} = {focus: true}) {
        form.classList.remove('loading', 'success', 'error', 'invalid');
        setFormError(form, '');

        const emailInput = form.querySelector('input[type="email"]');
        if (emailInput) {
            emailInput.disabled = false;
            emailInput.removeAttribute('aria-disabled');
            if (focus) emailInput.focus();
        }

        const submitBtn = form.querySelector('.bob-members-form__submit');
        if (submitBtn) {
            const defaultLabel = submitBtn.getAttribute('data-bob-default-label') || 'Submit';
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel;
        }

        setModalHeadingDefault();
    }

    async function submitMagicLink({form, email, name, formType}) {
        setFormError(form, '');
        setFormState(form, 'loading');

        trackEvent('members_modal_submit', {
            trigger: lastOpenMeta ? lastOpenMeta.trigger : undefined,
            placement: lastOpenMeta ? lastOpenMeta.placement : undefined,
            form: formType
        });

        try {
            const blockedUntilRaw = safeGet(localStorage, STORAGE.rateLimitUntil);
            const blockedUntil = blockedUntilRaw ? Number(blockedUntilRaw) : 0;
            if (blockedUntil && Number.isFinite(blockedUntil) && Date.now() < blockedUntil) {
                setFormState(form, 'error');
                setFormError(form, 'Too many requests. Please wait a minute and try again.');
                return;
            }

            const labels = buildMemberLabels({formType});
            await requestMagicLink({email, name, labels});
            setFormState(form, 'success');
            safeSet(localStorage, STORAGE.magicLinkSentAt, String(Date.now()));
            safeSet(sessionStorage, STORAGE.shownThisSession, '1');
            safeSet(localStorage, STORAGE.lastSubmitMeta, JSON.stringify({
                trigger: lastOpenMeta ? lastOpenMeta.trigger : null,
                placement: lastOpenMeta ? lastOpenMeta.placement : null,
                threshold: lastOpenMeta ? lastOpenMeta.threshold : null,
                form: formType
            }));
            applySuccessUI({form, email});

            trackEvent('members_magic_link_sent', {
                trigger: lastOpenMeta ? lastOpenMeta.trigger : undefined,
                placement: lastOpenMeta ? lastOpenMeta.placement : undefined,
                form: formType
            });
        } catch (e) {
            setFormState(form, 'error');
            const friendly = normalizeFriendlyError(e && e.message);
            setFormError(form, friendly);
            if (isRateLimitMessage(friendly)) {
                safeSet(localStorage, STORAGE.rateLimitUntil, String(Date.now() + RATE_LIMIT_BLOCK_MS));
            }
            trackEvent('members_magic_link_error', {
                trigger: lastOpenMeta ? lastOpenMeta.trigger : undefined,
                placement: lastOpenMeta ? lastOpenMeta.placement : undefined,
                form: formType
            });
        }
    }

    // Prevent full-page reloads if Ghost’s default members script isn’t ready yet,
    // and handle the request ourselves for maximum reliability (and to avoid double-submit).
    for (const form of Array.from(modalRoot.querySelectorAll('form[data-bob-members-form]'))) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();

            if (form.classList.contains('loading')) return;

            const formType = form.getAttribute('data-bob-members-form') || form.getAttribute('data-members-form') || 'signup';
            const emailInput = form.querySelector('input[type="email"]');
            const email = emailInput ? String(emailInput.value || '').trim() : '';
            if (!email) {
                form.classList.add('invalid');
                setFormState(form, 'error');
                setFormError(form, 'Please enter your email address.');
                if (emailInput) emailInput.focus();
                return;
            }

            const nameInput = form.querySelector('input[name="name"]');
            const name = nameInput ? String(nameInput.value || '').trim() : '';
            submitMagicLink({form, email, name, formType});
        }, true);
    }

    function shouldAutoPopup() {
        if (!autoPopupEnabledByTheme()) return false;
        if (!membersEnabled() || inviteOnly()) return false;
        if (isMember()) return false;
        if (!document.body || !(document.body.classList.contains('post-template') || document.body.classList.contains('single-post'))) {
            return false;
        }

        const params = new URLSearchParams(window.location.search || '');
        if (params.has('nopopup')) return false;
        const forcePopup = params.has('forcepopup');

        if (safeGet(localStorage, STORAGE.disabled) === '1') return false;
        if (!forcePopup) {
            if (safeGet(localStorage, STORAGE.subscribed) === '1') return false;
            if (safeGet(sessionStorage, STORAGE.shownThisSession) === '1') return false;
        }

        if (!forcePopup) {
            const magicLinkSentAtRaw = safeGet(localStorage, STORAGE.magicLinkSentAt);
            const magicLinkSentAt = magicLinkSentAtRaw ? Number(magicLinkSentAtRaw) : 0;
            if (magicLinkSentAt && Number.isFinite(magicLinkSentAt) && Date.now() - magicLinkSentAt < MAGIC_LINK_COOLDOWN_MS) {
                return false;
            }

            const dismissedAtRaw = safeGet(localStorage, STORAGE.dismissedAt);
            const dismissedAt = dismissedAtRaw ? Number(dismissedAtRaw) : 0;
            if (dismissedAt && Number.isFinite(dismissedAt) && Date.now() - dismissedAt < COOLDOWN_MS) {
                return false;
            }
        }

        return true;
    }

    function getPostScrollPercent() {
        const article = document.querySelector('.gh-article');
        if (!article) return 0;

        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const articleTop = article.getBoundingClientRect().top + scrollTop;
        const articleBottom = articleTop + article.offsetHeight;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const totalScrollable = Math.max(0, articleBottom - articleTop - viewportHeight);
        if (totalScrollable <= 0) return 100;

        const current = Math.min(Math.max(scrollTop - articleTop, 0), totalScrollable);
        return (current / totalScrollable) * 100;
    }

    function enableAutoPopup() {
        if (!shouldAutoPopup()) return;

        let triggered = false;
        let ticking = false;

        function maybeTrigger() {
            ticking = false;
            if (triggered) return;
            if (getPostScrollPercent() < 50) return;

            triggered = true;
            safeSet(sessionStorage, STORAGE.shownThisSession, '1');
            openModal('signup', {trigger: 'auto', placement: 'auto_scroll', scrollThreshold: 50});
        }

        function onScroll() {
            if (triggered || ticking) return;
            ticking = true;
            window.requestAnimationFrame(maybeTrigger);
        }

        window.addEventListener('scroll', onScroll, {passive: true});
        window.addEventListener('resize', onScroll);
        onScroll();
    }

    // Start auto-popup logic after a short delay so we don’t interrupt first paint.
    if (autoPopupEnabledByTheme()) {
        window.setTimeout(enableAutoPopup, 5000);
    }

    // Expose a tiny escape hatch for debugging and emergency disable.
    window.bobMembersModal = {
        open: (panel = 'signup') => openModal(panel, {trigger: 'manual', placement: 'api'}),
        close: () => closeModal({persistDismissal: false, reason: 'api'}),
        disableAutoPopup: () => safeSet(localStorage, STORAGE.disabled, '1'),
        enableAutoPopup: () => safeRemove(localStorage, STORAGE.disabled)
    };
})();

/* Post scroll progress (posts only): 404-style top bar */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    const progressBar = document.getElementById('bob-progress');
    if (!progressBar) return;

    const article = document.querySelector('.gh-article');
    if (!article) return;

    let isTicking = false;

    function updateProgress() {
        isTicking = false;

        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const articleTop = article.getBoundingClientRect().top + scrollTop;
        const articleBottom = articleTop + article.offsetHeight;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const totalScrollable = Math.max(0, articleBottom - articleTop - viewportHeight);
        if (totalScrollable <= 0) {
            progressBar.style.setProperty('--scroll', '100%');
            return;
        }

        const current = Math.min(Math.max(scrollTop - articleTop, 0), totalScrollable);
        const percent = Math.round((current / totalScrollable) * 100) + '%';
        progressBar.style.setProperty('--scroll', percent);
    }

    function onScrollOrResize() {
        if (isTicking) return;
        isTicking = true;
        window.requestAnimationFrame(updateProgress);
    }

    updateProgress();
    window.addEventListener('scroll', onScrollOrResize, {passive: true});
    window.addEventListener('resize', onScrollOrResize);
})();

/* Audio teaser (Web Speech MVP): visible teaser, play for members */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    const root = document.querySelector('[data-bob-audio-root]');
    if (!root) return;

    const fab = root.querySelector('[data-bob-audio-fab]');
    const panel = root.querySelector('[data-bob-audio-panel]');
    const closeBtn = root.querySelector('[data-bob-audio-close]');
    const locked = root.querySelector('[data-bob-audio-locked]');
    const unlocked = root.querySelector('[data-bob-audio-unlocked]');
    const unsupported = root.querySelector('[data-bob-audio-unsupported]');
    const hint = root.querySelector('[data-bob-audio-hint]');

    const signupBtn = root.querySelector('[data-bob-audio-signup]');
    const signinBtn = root.querySelector('[data-bob-audio-signin]');
    const fakePlayerBtn = root.querySelector('[data-bob-audio-fake-player]');
    const primaryAction = root.querySelector('[data-bob-audio-primary-action]');

    const playBtn = root.querySelector('[data-bob-audio-play]');
    const playIcon = root.querySelector('[data-bob-audio-play-icon]');
    const pauseIcon = root.querySelector('[data-bob-audio-pause-icon]');
    const statusText = root.querySelector('[data-bob-audio-status]');
    const metaText = root.querySelector('[data-bob-audio-meta]');
    const eq = root.querySelector('[data-bob-audio-eq]');

    const restartBtn = root.querySelector('[data-bob-audio-restart]');
    const stopBtn = root.querySelector('[data-bob-audio-stop]');
    const speedButtons = Array.from(root.querySelectorAll('[data-bob-audio-speed]'));

    const STORAGE = {
        teaserShown: 'BOB_AUDIO_TEASER_SHOWN_SESSION',
        pendingUnlockAt: 'BOB_AUDIO_PENDING_UNLOCK_AT',
        inlineTutorialShown: 'BOB_AUDIO_INLINE_TUTORIAL_SHOWN_V1'
    };

    const PENDING_UNLOCK_TTL_MS = 2 * 60 * 60 * 1000;

    const inlineTeaser = document.querySelector('[data-bob-audio-inline]');

    function safeGet(storage, key) {
        try {
            return storage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function safeSet(storage, key, value) {
        try {
            storage.setItem(key, value);
        } catch (e) {
            // ignore
        }
    }

    function safeRemove(storage, key) {
        try {
            storage.removeItem(key);
        } catch (e) {
            // ignore
        }
    }

    function membersEnabled() {
        return document.body && document.body.getAttribute('data-bob-members-enabled') === '1';
    }

    function isMember() {
        return document.body && document.body.getAttribute('data-bob-member') === '1';
    }

    function hasAccess() {
        return root.getAttribute('data-bob-audio-access') === '1';
    }

    function shouldUnlock() {
        return membersEnabled() && isMember() && hasAccess();
    }

    function getSlug() {
        return root.getAttribute('data-bob-audio-slug') || '';
    }

    function getLockPrimaryAction() {
        if (!primaryAction) return 'unknown';
        if (primaryAction.getAttribute('data-bob-members-modal') === 'signup') return 'signup';
        if (primaryAction.getAttribute('data-portal') === 'upgrade') return 'upgrade';
        const href = String(primaryAction.getAttribute('href') || '');
        if (href.includes('/portal/upgrade')) return 'upgrade';
        if (href.includes('/portal/signup')) return 'signup';
        return 'unknown';
    }

    function track(eventName, props = {}) {
        const plausible = window.plausible;
        if (typeof plausible !== 'function') return;

        const cleanedProps = {};
        for (const [key, value] of Object.entries(props || {})) {
            if (value === undefined || value === null) continue;
            cleanedProps[key] = String(value);
        }

        try {
            plausible(eventName, Object.keys(cleanedProps).length ? {props: cleanedProps} : undefined);
        } catch (e) {
            // ignore
        }
    }

    function isPinterestInApp() {
        const ua = String(navigator.userAgent || '');
        return /Pinterest/i.test(ua);
    }

    if (!membersEnabled()) {
        return;
    }

    // ---------- UI helpers ----------
    let isPanelOpen = false;
    let isTeaserVisible = false;
    let collapseTimer = null;

    // Draggable floating button + persisted position
    const POSITION_STORAGE_KEY = 'BOB_AUDIO_FAB_POS_V1';
    let positionInitialized = false;
    let hasUserPosition = false;
    let ignoreFabClickUntil = 0;

    function safeJsonParse(raw) {
        try {
            return JSON.parse(String(raw || ''));
        } catch (e) {
            return null;
        }
    }

    function clamp(value, min, max) {
        if (!Number.isFinite(value)) return min;
        return Math.min(Math.max(value, min), max);
    }

    function readStoredPosition() {
        const raw = safeGet(localStorage, POSITION_STORAGE_KEY);
        const parsed = safeJsonParse(raw);
        if (!parsed || typeof parsed !== 'object') return null;
        if (parsed.scope && String(parsed.scope) !== String(getPointerScope())) return null;
        const right = Number(parsed.right);
        const bottom = Number(parsed.bottom);
        if (!Number.isFinite(right) || !Number.isFinite(bottom)) return null;
        return {right, bottom};
    }

    function writeStoredPosition(pos) {
        if (!pos) return;
        safeSet(localStorage, POSITION_STORAGE_KEY, JSON.stringify({
            scope: getPointerScope(),
            right: Math.round(pos.right),
            bottom: Math.round(pos.bottom)
        }));
    }

    function getPointerScope() {
        try {
            if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return 'coarse';
        } catch (e) {
            // ignore
        }
        return 'fine';
    }

    function getFabRect() {
        if (!fab) return null;
        const rect = fab.getBoundingClientRect();
        if (!rect || !rect.width || !rect.height) return null;
        return rect;
    }

    function clampPosition(pos) {
        const rect = getFabRect();
        const viewportW = window.innerWidth || 0;
        const viewportH = window.innerHeight || 0;

        const fallbackSize = 48;
        const fabW = rect ? rect.width : fallbackSize;
        const fabH = rect ? rect.height : fallbackSize;

        const minRight = 8;
        const maxRight = Math.max(minRight, viewportW - fabW - 8);

        // Keep below the top header area on phones.
        const minBottom = 8;
        const maxBottom = Math.max(minBottom, viewportH - fabH - 84);

        return {
            right: clamp(Number(pos && pos.right), minRight, maxRight),
            bottom: clamp(Number(pos && pos.bottom), minBottom, maxBottom)
        };
    }

    function applyPosition(pos) {
        if (!pos) return;
        const next = clampPosition(pos);
        root.style.setProperty('--bob-audio-right', `${Math.round(next.right)}px`);
        root.style.setProperty('--bob-audio-bottom', `${Math.round(next.bottom)}px`);
        return next;
    }

    function getCurrentPosition() {
        const computed = window.getComputedStyle(root);
        const right = Number.parseFloat(computed.right || '16') || 16;
        const bottom = Number.parseFloat(computed.bottom || '110') || 110;
        return {right, bottom};
    }

    function ensurePositionInitialized() {
        if (positionInitialized) return;
        positionInitialized = true;

        const stored = readStoredPosition();
        if (stored) {
            hasUserPosition = true;
        }

        // We can only read computed right/bottom after the element is visible (hidden -> display:none).
        const computed = window.getComputedStyle(root);
        const baseRight = Number.parseFloat(computed.right || '16') || 16;
        const baseBottom = Number.parseFloat(computed.bottom || '110') || 110;
        const initial = stored || {right: baseRight, bottom: baseBottom};
        applyPosition(initial);
    }

    function getTopBlockingElementAtPoint(x, y) {
        if (!Number.isFinite(x) || !Number.isFinite(y)) return null;
        if (x < 0 || y < 0) return null;

        const viewportW = window.innerWidth || 0;
        const viewportH = window.innerHeight || 0;
        if (x > viewportW || y > viewportH) return null;

        if (!document.elementsFromPoint) return null;
        const elements = document.elementsFromPoint(x, y) || [];
        const top = elements && elements.length ? elements[0] : null;
        if (!top || !(top instanceof Element)) return null;
        if (top === document.documentElement || top === document.body) return null;
        if (root.contains(top)) return null;
        return top;
    }

    function rectsIntersect(a, b) {
        if (!a || !b) return false;
        return !(
            a.right <= b.left ||
            a.left >= b.right ||
            a.bottom <= b.top ||
            a.top >= b.bottom
        );
    }

    function ensureClearOfBottomBar() {
        if (!fab) return;
        const viewportW = window.innerWidth || 0;
        const viewportH = window.innerHeight || 0;
        if (!viewportW || !viewportH) return;

        const fabRect = fab.getBoundingClientRect();
        const probeY = Math.max(1, viewportH - 2);
        const bottomEl = getTopBlockingElementAtPoint(Math.round(viewportW / 2), probeY);
        if (!bottomEl) return;

        const style = window.getComputedStyle(bottomEl);
        if (style.position !== 'fixed' && style.position !== 'sticky') return;

        const rect = bottomEl.getBoundingClientRect();
        // Only treat as a bottom "dock" if it actually sits at the bottom and spans most of the width.
        if (rect.height < 40) return;
        if (rect.width < viewportW * 0.8) return;
        if (rect.top < viewportH * 0.5) return;

        const margin = 14;
        const safeTop = rect.top - margin;
        if (fabRect.bottom <= safeTop) return;

        const delta = fabRect.bottom - safeTop;
        const pos = getCurrentPosition();
        applyPosition({right: pos.right, bottom: pos.bottom + delta});
    }

    function ensureFabNotCovered() {
        if (!fab) return;
        const rect = fab.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        const blocking = getTopBlockingElementAtPoint(cx, cy);
        if (!blocking) return;

        // Prefer moving upward. If the obstacle is pinned to the right edge, also allow nudging left.
        const margin = 14;
        const obstacleRect = blocking.getBoundingClientRect();
        let pos = getCurrentPosition();

        const deltaUp = rect.bottom - (obstacleRect.top - margin);
        if (deltaUp > 0) pos = applyPosition({right: pos.right, bottom: pos.bottom + deltaUp}) || pos;

        // If still covered (e.g. overlay on bottom-right), try nudging left a bit.
        const rectAfter = fab.getBoundingClientRect();
        const stillBlocking = getTopBlockingElementAtPoint(
            rectAfter.left + rectAfter.width / 2,
            rectAfter.top + rectAfter.height / 2
        );
        if (stillBlocking) {
            const rightEdge = (window.innerWidth || 0) - margin;
            if (obstacleRect.right >= rightEdge - 30) {
                const deltaLeft = Math.min(160, obstacleRect.width + 16);
                applyPosition({right: pos.right + deltaLeft, bottom: pos.bottom});
            }
        }
    }

    function ensurePanelNotCovered() {
        if (!isPanelOpen || !panel) return;

        // Try a few times in case the overlay is tall.
        for (let i = 0; i < 3; i++) {
            const panelRect = panel.getBoundingClientRect();
            if (!panelRect.width || !panelRect.height) return;

            // Probe the bottom-left corner of the panel: that’s where the Mediavine mini video usually overlaps.
            const probeX = panelRect.left + 24;
            const probeY = panelRect.bottom - 24;
            const blocking = getTopBlockingElementAtPoint(probeX, probeY);
            if (!blocking) return;

            const obstacleRect = blocking.getBoundingClientRect();
            if (!rectsIntersect(panelRect, obstacleRect)) return;

            const margin = 16;
            const deltaUp = panelRect.bottom - (obstacleRect.top - margin);
            if (deltaUp <= 0) return;

            const pos = getCurrentPosition();
            applyPosition({right: pos.right, bottom: pos.bottom + deltaUp});
        }
    }

    function setFabExpanded(expanded) {
        root.classList.toggle('is-fab-expanded', Boolean(expanded));
    }

    function showTeaserImmediately() {
        if (root.hidden) root.hidden = false;

        if (!isTeaserVisible) {
            isTeaserVisible = true;
            ensurePositionInitialized();
            ensureClearOfBottomBar();
            ensureFabNotCovered();

            if (!safeGet(sessionStorage, STORAGE.teaserShown)) {
                safeSet(sessionStorage, STORAGE.teaserShown, '1');
                track('audio_teaser_shown', {slug: getSlug()});
            }
        }
    }

    function shouldShowTeaserControls() {
        return isPanelOpen || speech.state === 'playing' || speech.state === 'paused';
    }

    function updateTeaserVisibility() {
        if (shouldShowTeaserControls()) {
            showTeaserImmediately();
            return;
        }
        if (!root.hidden) root.hidden = true;
        isTeaserVisible = false;
    }

    function openPanel() {
        if (isPanelOpen) return;
        showTeaserImmediately();
        ensurePositionInitialized();
        ensureClearOfBottomBar();
        isPanelOpen = true;

        root.classList.add('is-open');
        setFabExpanded(true);
        if (panel) panel.setAttribute('aria-hidden', 'false');

        if (hint) {
            hint.hidden = !isPinterestInApp();
        }

        const unlockedNow = shouldUnlock();
        if (locked) locked.hidden = unlockedNow;
        if (unlocked) unlocked.hidden = !unlockedNow;

        if (unlockedNow) {
            setUnsupportedVisible(false);
            if (speech.state === 'playing') {
                setStatus('Playing', progressLabel(), {playing: true});
            } else if (speech.state === 'paused') {
                setStatus('Paused', progressLabel(), {playing: false});
            } else if (speech.state === 'ended') {
                setStatus('Finished', 'Tap restart to listen again', {playing: false});
            } else {
                setStatus('Ready', `Tap play • ${progressLabel()}`, {playing: false});
            }
            updateFabPlaybackState();
        } else {
            stopSpeech({trackStop: false});
        }

        window.requestAnimationFrame(() => {
            ensureClearOfBottomBar();
            ensurePanelNotCovered();
            ensureFabNotCovered();
        });
    }

    function closePanel() {
        if (!isPanelOpen) return;
        isPanelOpen = false;

        root.classList.remove('is-open');
        if (panel) panel.setAttribute('aria-hidden', 'true');

        // Treat close as "minimize": keep playback running so the reader can keep reading.
        if (collapseTimer) window.clearTimeout(collapseTimer);
        collapseTimer = window.setTimeout(() => {
            collapseTimer = null;
            if (!isPanelOpen) setFabExpanded(false);
        }, 150);

        updateTeaserVisibility();
    }

    function setUnsupportedVisible(visible) {
        if (unsupported) unsupported.hidden = !visible;
        if (playBtn) playBtn.disabled = Boolean(visible);
        if (restartBtn) restartBtn.disabled = Boolean(visible);
        if (stopBtn) stopBtn.disabled = Boolean(visible);
        speedButtons.forEach((btn) => (btn.disabled = Boolean(visible)));
    }

    function setStatus(primary, secondary, {playing} = {playing: false}) {
        if (statusText) statusText.textContent = String(primary || '');
        if (metaText) metaText.textContent = String(secondary || '');
        if (eq) eq.hidden = !playing;

        if (playIcon) playIcon.hidden = Boolean(playing);
        if (pauseIcon) pauseIcon.hidden = !playing;
    }

    // Close when clicking outside the panel/button.
    document.addEventListener('click', (event) => {
        if (!isPanelOpen) return;
        const target = event.target;
        if (!target || !(target instanceof Element)) return;
        if (root.contains(target)) return;
        closePanel();
    }, true);

    // Escape closes the panel.
    document.addEventListener('keydown', (event) => {
        if (!isPanelOpen) return;
        if (event.key !== 'Escape') return;
        event.preventDefault();
        closePanel();
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', (event) => {
            event.preventDefault();
            track('audio_panel_minimized', {slug: getSlug(), state: root.classList.contains('is-playing') ? 'playing' : root.classList.contains('is-paused') ? 'paused' : 'idle'});
            closePanel();
        });
    }

    if (fab) {
        const drag = {
            active: false,
            didDrag: false,
            pointerId: null,
            startX: 0,
            startY: 0,
            startRight: 0,
            startBottom: 0,
            lastPos: null
        };

        function onFabPointerDown(event) {
            if (!event || (event.isPrimary === false)) return;
            ensurePositionInitialized();

            drag.active = true;
            drag.didDrag = false;
            drag.pointerId = event.pointerId;
            drag.startX = event.clientX;
            drag.startY = event.clientY;

            const computed = window.getComputedStyle(root);
            drag.startRight = Number.parseFloat(computed.right || '16') || 16;
            drag.startBottom = Number.parseFloat(computed.bottom || '110') || 110;

            try {
                fab.setPointerCapture(event.pointerId);
            } catch (e) {
                // ignore
            }
        }

        function onFabPointerMove(event) {
            if (!drag.active) return;
            if (event.pointerId != null && drag.pointerId != null && event.pointerId !== drag.pointerId) return;

            const dx = event.clientX - drag.startX;
            const dy = event.clientY - drag.startY;

            if (!drag.didDrag && Math.hypot(dx, dy) < 8) return;
            if (!drag.didDrag) {
                drag.didDrag = true;
                root.classList.add('is-dragging');
                setFabExpanded(false);
            }

            const next = applyPosition({
                right: drag.startRight - dx,
                bottom: drag.startBottom - dy
            });
            if (next) {
                hasUserPosition = true;
                drag.lastPos = next;
            }
        }

        function onFabPointerUp(event) {
            if (!drag.active) return;
            if (event && event.pointerId != null && drag.pointerId != null && event.pointerId !== drag.pointerId) return;

            drag.active = false;
            drag.pointerId = null;
            root.classList.remove('is-dragging');

            if (drag.didDrag) {
                if (drag.lastPos) writeStoredPosition(drag.lastPos);
                drag.lastPos = null;
                ignoreFabClickUntil = Date.now() + 400;
            }
        }

        fab.addEventListener('pointerdown', onFabPointerDown);
        fab.addEventListener('pointermove', onFabPointerMove);
        fab.addEventListener('pointerup', onFabPointerUp);
        fab.addEventListener('pointercancel', onFabPointerUp);

        fab.addEventListener('click', (event) => {
            event.preventDefault();
            if (ignoreFabClickUntil && Date.now() < ignoreFabClickUntil) return;
            if (isPanelOpen) {
                track('audio_panel_minimized', {slug: getSlug(), state: root.classList.contains('is-playing') ? 'playing' : root.classList.contains('is-paused') ? 'paused' : 'idle'});
                closePanel();
                return;
            }
            const state = root.classList.contains('is-fab-expanded') ? 'pill' : 'circle';
            track('audio_teaser_clicked', {state, member: isMember() ? '1' : '0', slug: getSlug()});
            openPanel();
        });
    }

    if (signupBtn) {
        signupBtn.addEventListener('click', (event) => {
            if (event && event.isTrusted === false) return;
            track('audio_locked_primary_clicked', {slug: getSlug(), action: 'signup', source: 'button'});
            track('audio_locked_signup_clicked', {slug: getSlug(), source: 'button'});
            safeSet(localStorage, STORAGE.pendingUnlockAt, String(Date.now()));
            closePanel();
        }, true);
    }

    if (signinBtn) {
        signinBtn.addEventListener('click', (event) => {
            if (event && event.isTrusted === false) return;
            track('audio_locked_signin_clicked', {slug: getSlug(), source: 'button'});
            safeSet(localStorage, STORAGE.pendingUnlockAt, String(Date.now()));
            closePanel();
        }, true);
    }

    if (primaryAction && !primaryAction.hasAttribute('data-bob-audio-signup')) {
        primaryAction.addEventListener('click', (event) => {
            if (event && event.isTrusted === false) return;
            const action = getLockPrimaryAction();
            track('audio_locked_primary_clicked', {slug: getSlug(), action, source: 'button'});
        }, true);
    }

    if (fakePlayerBtn) {
        fakePlayerBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const action = getLockPrimaryAction();
            track('audio_locked_primary_clicked', {slug: getSlug(), action, source: 'player'});
            if (action === 'signup') {
                track('audio_locked_signup_clicked', {slug: getSlug(), source: 'player'});
                safeSet(localStorage, STORAGE.pendingUnlockAt, String(Date.now()));
            }

            closePanel();
            if (action === 'upgrade') {
                if (primaryAction && typeof primaryAction.click === 'function') primaryAction.click();
                return;
            }

            const targetEl = action === 'signup' ? (signupBtn || primaryAction) : primaryAction;
            if (targetEl) {
                // Dispatch a synthetic click so the members modal listener opens with correct placement,
                // without double-counting our audio click tracking.
                try {
                    targetEl.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
                } catch (e) {
                    // ignore
                }
            }
        }, true);
    }

    // ---------- Inline teaser (after featured image) ----------
    if (inlineTeaser) {
        let inlineTrackedShown = false;

        function trackInlineShown() {
            if (inlineTrackedShown) return;
            inlineTrackedShown = true;
            track('audio_inline_shown', {slug: getSlug(), member: isMember() ? '1' : '0', access: hasAccess() ? '1' : '0'});
        }

        if (typeof IntersectionObserver === 'function') {
            const io = new IntersectionObserver((entries) => {
                for (const entry of entries) {
                    if (!entry.isIntersecting) continue;
                    trackInlineShown();
                    io.disconnect();
                    break;
                }
            }, {threshold: 0.35});
            io.observe(inlineTeaser);
        } else {
            window.setTimeout(trackInlineShown, 0);
        }

        let tutorialMinimizeTimer = null;

        function cancelTutorialMinimize() {
            if (!tutorialMinimizeTimer) return;
            window.clearTimeout(tutorialMinimizeTimer);
            tutorialMinimizeTimer = null;
        }

        function scheduleTutorialMinimize() {
            cancelTutorialMinimize();

            const cancelOnInteract = () => cancelTutorialMinimize();
            if (panel) panel.addEventListener('pointerdown', cancelOnInteract, {once: true, capture: true});
            if (panel) panel.addEventListener('keydown', cancelOnInteract, {once: true, capture: true});
            if (fab) fab.addEventListener('pointerdown', cancelOnInteract, {once: true, capture: true});

            tutorialMinimizeTimer = window.setTimeout(() => {
                tutorialMinimizeTimer = null;
                if (!isPanelOpen) return;
                track('audio_inline_tutorial_autominimized', {slug: getSlug()});
                closePanel();
            }, 3200);
        }

        inlineTeaser.addEventListener('click', (event) => {
            if (event && event.isTrusted === false) return;

            track('audio_inline_clicked', {
                slug: getSlug(),
                member: isMember() ? '1' : '0',
                access: hasAccess() ? '1' : '0'
            });

            if (!isMember()) {
                safeSet(localStorage, STORAGE.pendingUnlockAt, String(Date.now()));
                return;
            }

            if (!hasAccess()) {
                openPanel();
                track('audio_inline_requires_upgrade', {slug: getSlug()});
                return;
            }

            if (speech.state === 'playing') {
                openPanel();
                track('audio_inline_panel_opened', {slug: getSlug(), state: 'playing'});
                return;
            }

            if (speech.state === 'paused') {
                resumeSpeech();
                openPanel();
                track('audio_inline_panel_opened', {slug: getSlug(), state: 'paused'});
                return;
            }

            const isFirstInlineTutorial = !safeGet(localStorage, STORAGE.inlineTutorialShown);
            const startIndex = speech.state === 'ended' ? 0 : (speech.chunkIndex || 0);

            if (isFirstInlineTutorial) {
                safeSet(localStorage, STORAGE.inlineTutorialShown, '1');
                openPanel();
                track('audio_inline_tutorial_shown', {slug: getSlug()});
                startSpeech({index: startIndex, trackStartEvent: true, source: 'inline'});
                scheduleTutorialMinimize();
                return;
            }

            if (isPanelOpen) closePanel();
            setFabExpanded(false);
            startSpeech({index: startIndex, trackStartEvent: true, source: 'inline'});
        });
    }

    let isTicking = false;
    let lastCollisionCheckAt = 0;
    function onScroll() {
        if (isTicking) return;
        isTicking = true;
        window.requestAnimationFrame(() => {
            isTicking = false;
            if (!isTeaserVisible) return;

            if (root.classList.contains('is-dragging')) return;
            const rootRect = root.getBoundingClientRect();
            if (!rootRect.width || !rootRect.height) return;
            const now = Date.now();
            if (now - lastCollisionCheckAt < 350) return;
            lastCollisionCheckAt = now;

            ensureClearOfBottomBar();
            if (isPanelOpen) {
                ensurePanelNotCovered();
            } else {
                ensureFabNotCovered();
            }
        });
    }

    window.addEventListener('scroll', onScroll, {passive: true});
    window.addEventListener('resize', onScroll);
    onScroll();

    // ---------- Web Speech playback ----------
    const speech = {
        chunks: [],
        chunkIndex: 0,
        rate: 1,
        state: 'idle', // idle | playing | paused | ended
        utterance: null,
        pendingStartEvent: false,
        pendingStartSource: null
    };

    function updateFabPlaybackState() {
        root.classList.toggle('is-playing', speech.state === 'playing');
        root.classList.toggle('is-paused', speech.state === 'paused');
    }

    function progressLabel() {
        const total = speech.chunks.length;
        const part = Math.min(Math.max(speech.chunkIndex + 1, 1), total || 1);
        return total
            ? `Speed ${speech.rate.toFixed(1)}× • Part ${part}/${total}`
            : `Speed ${speech.rate.toFixed(1)}×`;
    }

    // If a member just signed in on this device after a lock click, auto-open the panel.
    (function () {
        const pendingAt = Number(safeGet(localStorage, STORAGE.pendingUnlockAt) || 0);
        if (!pendingAt) return;
        if (Date.now() - pendingAt > PENDING_UNLOCK_TTL_MS) {
            safeRemove(localStorage, STORAGE.pendingUnlockAt);
            return;
        }
        // Only auto-open once the viewer becomes a member. For paid posts, the panel will still be locked,
        // but opening it is useful because it shows the upgrade CTA immediately.
        if (!isMember()) return;
        safeRemove(localStorage, STORAGE.pendingUnlockAt);

        // Show immediately (even before scroll), but don’t autoplay (needs a user gesture).
        openPanel();
    })();

    function webSpeechSupported() {
        return Boolean(window.speechSynthesis && window.SpeechSynthesisUtterance);
    }

    function getArticleText() {
        const content = document.querySelector('.gh-content.entry-content');
        if (!content) return '';

        const title = root.getAttribute('data-bob-audio-title') || '';
        const body = String(content.innerText || '').trim();
        const combined = [title.trim(), body].filter(Boolean).join('\n\n');
        return combined
            .replace(/\\u00a0/g, ' ')
            .replace(/[ \\t]+\\n/g, '\\n')
            .replace(/\\n{3,}/g, '\\n\\n')
            .trim();
    }

    function splitIntoChunks(text) {
        const cleaned = String(text || '').replace(/\\s+/g, ' ').trim();
        if (!cleaned) return [];

        const sentences = cleaned.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [cleaned];
        const chunks = [];
        let current = '';

        const maxLen = 240;

        for (const sentence of sentences) {
            const next = current ? `${current} ${sentence}` : sentence;
            if (next.length <= maxLen) {
                current = next;
                continue;
            }

            if (current) chunks.push(current.trim());
            current = sentence.trim();

            while (current.length > maxLen) {
                chunks.push(current.slice(0, maxLen).trim());
                current = current.slice(maxLen).trim();
            }
        }

        if (current) chunks.push(current.trim());
        return chunks.filter(Boolean);
    }

    function speakChunk() {
        if (!shouldUnlock()) {
            openPanel();
            return;
        }

        if (!webSpeechSupported()) {
            setUnsupportedVisible(true);
            setStatus('Unavailable', 'Try opening in Safari/Chrome', {playing: false});
            track('audio_unsupported', {reason: 'no_speechSynthesis', slug: getSlug()});
            return;
        }

        if (!speech.chunks.length) {
            speech.chunks = splitIntoChunks(getArticleText());
        }

        if (!speech.chunks.length) {
            setUnsupportedVisible(true);
            setStatus('Unavailable', 'Could not read this post', {playing: false});
            track('audio_unsupported', {reason: 'empty_text', slug: getSlug()});
            return;
        }

        const total = speech.chunks.length;
        const part = Math.min(Math.max(speech.chunkIndex + 1, 1), total);
        const label = total ? `Speed ${speech.rate.toFixed(1)}× • Part ${part}/${total}` : `Speed ${speech.rate.toFixed(1)}×`;

        const text = speech.chunks[speech.chunkIndex];
        if (!text) {
            speech.state = 'ended';
            setStatus('Finished', 'Tap restart to listen again', {playing: false});
            track('audio_completed', {slug: getSlug()});
            updateTeaserVisibility();
            return;
        }

        const utterance = new window.SpeechSynthesisUtterance(text);
        utterance.rate = speech.rate;
        utterance.onstart = () => {
            setUnsupportedVisible(false);
            setStatus('Playing', label, {playing: true});
            updateFabPlaybackState();
            if (speech.pendingStartEvent) {
                speech.pendingStartEvent = false;
                const startSource = speech.pendingStartSource;
                speech.pendingStartSource = null;
                track('audio_play_started', {speed: speech.rate.toFixed(1), slug: getSlug(), source: startSource || undefined});
            }
        };
        utterance.onend = () => {
            if (speech.state === 'paused') return;
            if (speech.state === 'idle') return;

            speech.chunkIndex += 1;
            if (speech.chunkIndex >= speech.chunks.length) {
                speech.state = 'ended';
                setStatus('Finished', 'Tap restart to listen again', {playing: false});
                updateFabPlaybackState();
                track('audio_completed', {slug: getSlug()});
                updateTeaserVisibility();
                return;
            }

            speakChunk();
        };
        utterance.onerror = () => {
            speech.state = 'idle';
            setUnsupportedVisible(true);
            setStatus('Unavailable', 'Try opening in Safari/Chrome', {playing: false});
            updateFabPlaybackState();
            track('audio_unsupported', {reason: isPinterestInApp() ? 'pinterest_inapp' : 'speech_error', slug: getSlug()});
            updateTeaserVisibility();
        };

        speech.utterance = utterance;
        window.speechSynthesis.speak(utterance);
    }

    function startSpeech({index, trackStartEvent, source}) {
        if (!shouldUnlock()) {
            openPanel();
            return;
        }

        if (!webSpeechSupported()) {
            setUnsupportedVisible(true);
            setStatus('Unavailable', 'Try opening in Safari/Chrome', {playing: false});
            track('audio_unsupported', {reason: 'no_speechSynthesis', slug: getSlug()});
            return;
        }

        if (!speech.chunks.length) {
            speech.chunks = splitIntoChunks(getArticleText());
        }

        if (!speech.chunks.length) {
            setUnsupportedVisible(true);
            setStatus('Unavailable', 'Could not read this post', {playing: false});
            track('audio_unsupported', {reason: 'empty_text', slug: getSlug()});
            return;
        }

        showTeaserImmediately();
        speech.chunkIndex = Math.min(Math.max(Number(index) || 0, 0), speech.chunks.length - 1);
        speech.state = 'playing';
        speech.pendingStartEvent = Boolean(trackStartEvent);
        speech.pendingStartSource = trackStartEvent && source ? String(source) : null;

        try {
            window.speechSynthesis.cancel();
        } catch (e) {
            // ignore
        }

        speakChunk();
    }

    function pauseSpeech() {
        if (speech.state !== 'playing') return;
        speech.state = 'paused';
        showTeaserImmediately();
        try {
            window.speechSynthesis.pause();
        } catch (e) {
            // ignore
        }
        setStatus('Paused', progressLabel(), {playing: false});
        updateFabPlaybackState();
        track('audio_paused', {slug: getSlug()});
    }

    function resumeSpeech() {
        if (speech.state !== 'paused') return;
        speech.state = 'playing';
        showTeaserImmediately();
        try {
            window.speechSynthesis.resume();
        } catch (e) {
            // ignore
        }
        setStatus('Playing', progressLabel(), {playing: true});
        updateFabPlaybackState();
        track('audio_resumed', {slug: getSlug()});
    }

    function stopSpeech({trackStop} = {trackStop: true}) {
        const wasActive = speech.state === 'playing' || speech.state === 'paused';
        speech.state = 'idle';
        speech.chunkIndex = 0;
        speech.utterance = null;
        try {
            window.speechSynthesis.cancel();
        } catch (e) {
            // ignore
        }

        if (wasActive) {
            setStatus('Ready', `Tap play • ${progressLabel()}`, {playing: false});
            updateFabPlaybackState();
            if (trackStop) track('audio_stopped', {slug: getSlug()});
        }

        updateTeaserVisibility();
    }

    function restartSpeech() {
        stopSpeech({trackStop: false});
        startSpeech({index: 0, trackStartEvent: true, source: 'restart'});
    }

    function setRate(nextRate) {
        const rate = Number(nextRate);
        if (!rate || !Number.isFinite(rate)) return;
        speech.rate = rate;

        speedButtons.forEach((btn) => {
            btn.classList.toggle('is-active', btn.getAttribute('data-bob-audio-speed') === String(nextRate));
        });

        if (speech.state === 'playing' || speech.state === 'paused') {
            const resumeIndex = speech.chunkIndex;
            stopSpeech({trackStop: false});
            startSpeech({index: resumeIndex, trackStartEvent: false});
        } else if (speech.state === 'ended') {
            setStatus('Finished', progressLabel(), {playing: false});
            updateFabPlaybackState();
        } else {
            setStatus('Ready', progressLabel(), {playing: false});
            updateFabPlaybackState();
        }

        track('audio_speed_changed', {slug: getSlug(), speed: speech.rate.toFixed(1)});
    }

    if (playBtn) {
        playBtn.addEventListener('click', () => {
            if (!shouldUnlock()) {
                openPanel();
                return;
            }

            if (speech.state === 'playing') {
                pauseSpeech();
                return;
            }

            if (speech.state === 'paused') {
                resumeSpeech();
                return;
            }

            if (speech.state === 'ended') {
                restartSpeech();
                return;
            }

            startSpeech({index: speech.chunkIndex || 0, trackStartEvent: true, source: 'panel'});
        });
    }

    if (stopBtn) {
        stopBtn.addEventListener('click', () => {
            track('audio_stop_clicked', {slug: getSlug()});
            stopSpeech({trackStop: true});
        });
    }

    if (restartBtn) {
        restartBtn.addEventListener('click', () => {
            track('audio_restart_clicked', {slug: getSlug()});
            restartSpeech();
        });
    }

    speedButtons.forEach((btn) => {
        btn.addEventListener('click', () => setRate(btn.getAttribute('data-bob-audio-speed')));
    });

    // Ensure we stop speech on navigation / unload.
    window.addEventListener('beforeunload', () => stopSpeech({trackStop: false}));
})();
